import { DocumentVariableListPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import AllAvailableVariablesList from 'modules/documents/components/DocumentTemplates/Content/AllAvailableVariablesList'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const VariableTemplatesPage = () => {
  const { loading, data, error } = useQuery(DocumentVariableListPageDocument, {})

  const authorized = !loading && data?.documents?._policies?.templateManageDocumentTemplates.can

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={error}
      showHeader={false}
      authorized={authorized}
    >
      <AllAvailableVariablesList />
    </ResponsivePage.Body>
  )
}

export default VariableTemplatesPage
